import { RouteDeclaration, resolveFromParam, configureStates } from "../../core/router/router-helper.provider";
import { Transition } from "angular-ui-router";
import moment from "moment";
import angular from "angular";

export const routes: RouteDeclaration[] = [{
    state: "eventsScheduling",
    config: {
        name: "eventsScheduling",
        url: "/scheduling"
    }
}, {
    state: "eventsScheduling.assignedEventsCalendar",
    config: {
        name: "eventsScheduling.assignedEventsCalendar",
        url: "/eventscalendar?mode&{startDate:date}&{endDate:date}&{divisionID:int}&{icdOfficeID:int}",
        component: "apexAssignedEventsCalendarContainer",
        params: {
            mode: { value: "week", squash: true, dynamic: true },
            startDate: { dynamic: true },
            endDate: { dynamic: true },
            divisionID: { dynamic: true },
            icdOfficeID: { dynamic: true }
        },
        resolve: {
            calendar: ($transition$: Transition) => {
                'ngInject';
                let { mode, startDate, endDate } = $transition$.params() as (
                    { mode: string, startDate: Date, endDate: Date});
                if (mode !== "week" && mode !== "day") {
                    mode = "week";
                }
                if (mode === "week") {
                    startDate = startDate || moment().startOf("isoWeek").toDate();
                    endDate = endDate || moment().endOf("isoWeek").toDate();
                } else {
                    startDate = startDate || moment().startOf("day").toDate();
                    endDate = endDate || moment().endOf("day").toDate();
                }
                return { mode, startDate, endDate };
            },
            icdOfficeID: resolveFromParam("icdOfficeID"),
            divisionID: resolveFromParam("divisionID")
        },
        data: {
            pageHeader: "Events Calendar"
        }
    }
}];

export const EventsSchedulingRoutingModule = angular
    .module("apex.mainApp.eventsScheduling.routing", [])
    .run(configureStates(routes))
    .name;

